import { render, staticRenderFns } from "./user_course_detail.vue?vue&type=template&id=ee0f2530&scoped=true"
import script from "./user_course_detail.vue?vue&type=script&lang=js"
export * from "./user_course_detail.vue?vue&type=script&lang=js"
import style0 from "./user_course_detail.css?vue&type=style&index=0&id=ee0f2530&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0f2530",
  null
  
)

export default component.exports